import apiService from "@services/api.js";
import { createLogger } from '@utils/logger.js';

class ContactFormController {
    constructor(parameters) {
        if(ContactFormController.instance) return ContactFormController.instance;
        ContactFormController.instance = this;

        this.logger = createLogger('ContactFormController');

        this.initListeners();
    }


    async initListeners(){

        document.addEventListener('click', async (e) => {
            const targetElement = e.target;
            if(targetElement.id === "contactSubmitButton"){
                e.preventDefault();
                await this.submitForm();
            }
        });
    }

    async submitForm() {
        const form = document.getElementById("contactForm");
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        try {
            const response = await apiService.apiCall("/contact", "POST", data);
            form.reset();
            alert("Nachricht erfolgreich gesendet!");
            window.location.href = "/";
        } catch (error) {
            this.logger.error("Form submission error:", error);
            alert("Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.");
        }
    }

}

const contactFormController = new ContactFormController();
export default contactFormController;